import { Button } from '@blueprintjs/core';
import { renderFilteredItems } from '@blueprintjs/select';
import classNames from 'classnames';
import * as React from 'react';

import {
  FilterableCollapsibleBlock,
  FilterableCollapsibleBlockProps,
  FilterableItem,
} from 'src/components/FilterableCollapsibleBlock';
import {
  TableColumnChildren,
  TableItemRenderer,
} from 'src/containers/ProjectDiagram/components/resourceDrawer/TableItemRenderer';
import { TableWrapper } from 'src/containers/ProjectDiagram/components/resourceDrawer/TableWrapper';
import * as copy from 'src/templates/copy';

export type FilterableCollapsibleTableProps<ItemType extends FilterableItem> =
  Omit<
    FilterableCollapsibleBlockProps<ItemType>,
    'itemListRenderer' | 'itemRenderer'
  > & {
    children: TableColumnChildren<ItemType>;
    hasHiddenUntilHover?: boolean;
    testId?: string;
  };

export const FilterableCollapsibleTable = <ItemType extends FilterableItem>({
  children,
  className,
  hasHiddenUntilHover,
  header,
  items,
  testId,
}: FilterableCollapsibleTableProps<ItemType>) => {
  return (
    <FilterableCollapsibleBlock
      className={className}
      header={header}
      itemListRenderer={(listProps) => (
        <TableWrapper columns={children} testId={testId}>
          {renderFilteredItems(
            listProps,
            <tr>
              <td colSpan={Array.isArray(children) ? children.length : 1}>
                <Button
                  alignText="left"
                  className={classNames(
                    'sd-no-events',
                    'sd-table-drawer-cell-button'
                  )}
                  minimal
                  text={copy.components.defaults.noResults}
                />
              </td>
            </tr>
          )}
        </TableWrapper>
      )}
      itemRenderer={(item, itemProps) => {
        if (!itemProps.modifiers.matchesPredicate) {
          return null;
        }
        return (
          <TableItemRenderer
            key={item.value}
            columns={children}
            hasHiddenUntilHover={hasHiddenUntilHover}
            item={item}
          />
        );
      }}
      items={items}
    />
  );
};
